import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ITasklistProcess } from '@/api/tasklist';
import useTenantState from './tenant.state';
import axios from 'axios';
import { env } from '@/utils/constants/env';
import { keycloakAuth } from '@/utils/auth/keycloak';

type Store = {
  businessProcesses: ITasklistProcess[] | null;
  loadBusinessProcesses: () => Promise<void>;
  isLoading: boolean;
  getProcessName: (processId: string) => string;
};

const useProcessesState = create<Store>()(
  persist(
    (set, get) => ({
      businessProcesses: [],
      isLoading: false,
      loadBusinessProcesses: async () => {
        set({ isLoading: true });
        const activeTenant = useTenantState.getState().currentTenant;
        const activeToken = await keycloakAuth.getValidToken();

        const response = await axios.get(env.apiTasklistBaseUrl + `/api/v1/tasklist/processes`, {
          headers: {
            Authorization: `Bearer ${activeToken}`,
            'Content-Type': 'application/json',
            'X-Active-Tenant': activeTenant?.slug,
          },
        });

        if (response.status !== 200) {
          set({ isLoading: false });
          throw new Error('Failed to fetch tenants');
        }

        set({ businessProcesses: response.data.data, isLoading: false });
      },
      getProcessName: (processKey: string) => {
        const process = get()?.businessProcesses?.find(p => p.key === processKey);
        return process ? process.name : '';
      },
    }),
    {
      name: 'processes-storage', // unique name for localStorage key
      storage: createJSONStorage(() => localStorage), // use localStorage
      partialize: state => ({ businessProcesses: state.businessProcesses }), // only persist the businessProcesses
    },
  ),
);

export default useProcessesState;
